import { ArrowBackIos, ArrowRightAlt } from '@material-ui/icons';
import React from 'react';
import ReactOwlCarousel from 'react-owl-carousel';
import { Link } from 'react-router-dom';
import { ImageUrl } from '../../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
export const ShopDiamondShape = () => {
    return (
        <>
            <section className='shop_diamond_shape my-5 pb-0'>
                <div className='container'>
                    <div className='title-box text-center mb-4'>
                        <h2>SHOP DIAMONDS BY SHAPE</h2>
                        <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/line-black.png`} alt='' />
                    </div>

                    <ReactOwlCarousel className="owl-main owl-theme"
                        nav
                        navText={['', '']}
                        dots={false}
                        margin={30}
                        items={4}
                        responsive={
                            {
                                0: {
                                    center: true,
                                    items: 3,
                                    nav: false
                                },
                                450: {
                                    center: true,
                                    items: 4,
                                    nav: false
                                },
                                992: {
                                    center: true,
                                    items: 4,
                                    nav: false
                                },
                                1024: {
                                    center: false,
                                    items: 4,
                                    nav: true
                                }
                            }
                        }
                        loop>
                        <div className='item text-center'>
                            <Link to="diamonds/shape=Asscher">
                                <LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Asscher.png`} alt='' />
                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Asscher">Asscher</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Cushion"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Cushion.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Cushion">Cushion</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Emerald"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Emerald.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Emerald">Emerald</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Heart"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Heart.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Heart">Heart</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Marquise"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Marquise.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Marquise">Marquise</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Oval"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Oval.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Oval">Oval</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Pear"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Pear.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Pear">Pear</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Princess"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Princess.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Princess">Princess</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Radiant"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Radiant.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Radiant">Radiant</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                        <div className='item text-center'>
                            <Link to="diamonds/shape=Round"><LazyLoadImage src={`${ImageUrl}theme/newyork/Slider/Round.png`} alt='' />

                                <div className='content position-relative'>
                                    <Link to="diamonds/shape=Round">Round</Link>
                                    <p className='m-0'>This unique shape is a square emerald, with linear facets.</p>
                                </div>
                            </Link>
                        </div>

                    </ReactOwlCarousel>
                </div>
            </section>
        </>
    )
}
